import { render } from "./InputDate.vue?vue&type=template&id=519a9e25"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"
script.render = render

export default script